var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { TextFields, Input } from '../../Input';
import { useEmail, emailValues } from '../Providers';
export var EmailInformation = function () {
    var _a = useEmail(), errorText = _a.errorText, showRequired = _a.showRequired;
    return (_jsx(_Fragment, { children: _jsx(TextFields, __assign({ label: "Email", htmlFor: emailValues.email.props.id, errorText: errorText, showRequired: showRequired }, { children: _jsx(Input, __assign({}, emailValues.email.props)) })) }));
};
//# sourceMappingURL=Email.js.map